import {MainApi} from "./MainApi";
import {TermsCategory} from "../types/terms";

export class TermsApi {

  static baseUrl = `${MainApi.urlPrefix}/user/terms`;

  static getTermByCategory = (category: TermsCategory) => () =>
    MainApi.api.get(`${TermsApi.baseUrl}/${category}`);
}